import { FunctionComponent} from 'preact';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import styles from './../styles.module.scss';

interface PaginationButtonProps {
  onClick: (direction: string) => void;
  direction: string;
}

const PaginationButton: FunctionComponent<PaginationButtonProps> = ({
  onClick,
  direction,
}: PaginationButtonProps) => (
  <button
    className={`${styles.paginate} ${styles[direction]}`}
    onClick={(): void => onClick(direction)}
  >
    <span className={styles.arrow}>
      <ArrowForwardIosIcon />
    </span>
  </button>
);

export default PaginationButton;
